import React from 'react';

import { MenuItem } from '@mui/material';
import produce from 'immer';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import classes from 'components/common/GlobalFiltersInPage/components/FiltersDropdown/FiltersDropdown.scss';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { Button } from 'components/DesignSystem/Button';
import { CustomizedDropdownMenu, CustomizedTooltip } from 'components/common';

const FiltersDropdown = ({ selectedFiltersOptions, setSelectedFiltersOptions, methods, handleFilters }) => {
    const handleSelection = (filterKey) => {
        methods.setValue(filterKey, null);

        setSelectedFiltersOptions(
            produce(selectedFiltersOptions, (draft) => {
                draft[filterKey].isSelected = !draft[filterKey].isSelected;
                return draft;
            }),
        );

        handleFilters?.();
    };

    return (
        <div data-testid={'more-filters-button'}>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`More Filters`}
                        triggerElement={
                            <Button
                                endIcon={
                                    <Icon
                                        name={'header-arrow-down'}
                                        size={'15px'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                startIcon={<Icon name={'filter'} size={'15px'} color={'var(--button-secondary-fg)'} />}
                                variant={'secondary'}
                            >
                                More Filters
                            </Button>
                        }
                    />
                }
                closeDropdownOnItemClick={false}
            >
                {Object.entries(selectedFiltersOptions).map(([key, item]) => {
                    const isSelected = item.isSelected === undefined || item.isSelected;

                    return (
                        <MenuItem key={key} onClick={() => handleSelection(key)}>
                            <div className={classes.customizeFilterContainerRow}>
                                <span>{item.label}</span>

                                {isSelected ? (
                                    <span className={classes.remove}>
                                        <Icon name="filter-x-icon" size="2rem" color="#cccccc" />
                                        <span>Remove</span>
                                    </span>
                                ) : (
                                    <span className={classes.add}>
                                        <Icon name="Governance-top-right-tick" size="1.3rem" color="#cccccc" />
                                        <span>Add</span>
                                    </span>
                                )}
                            </div>
                        </MenuItem>
                    );
                })}
            </CustomizedDropdownMenu>
        </div>
    );
};

export default React.memo(FiltersDropdown);
